<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-02-10 10:52:56
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-04-20 13:46:20
-->
<template>
    <div class="cooperData">
        <el-dialog title="查看合作数据" width="30%" :visible.sync="dialogCooperVisible">
            <div class="tipsBox">
                <tips-box></tips-box>
            </div>
            <div class="tips">
                <p class="yx-color-text-primary">注意：在合作进度管理中修改商品机制，仅对相应的{{drName}}生效！</p>
            </div>
            <div class="product_box">
                <product-box :row="row" :tabName="tabName"></product-box>
            </div>
            <div class="user_info_box mt-10">
                <user-info-box :row="row"></user-info-box>
            </div>
            <div class="mt-20">
               <p class="yx-color-text-primary font-bold">本次合作战报</p>
               <p class="fz-12 yx-color-info mt-6">开始合作时间：2021-12-12  12:12:12</p>
               <div class="flex flex-just-around flex-align-center mt-20">
                   <div class="align-center">
                       <p class="yx-color-text-primary font-bold">323</p>
                       <p class="fz-12 mt-6 yx-color-info">开播场次</p>
                   </div>
                   <div class="align-center">
                       <p class="yx-color-text-primary font-bold">323</p>
                       <p class="fz-12 mt-6 yx-color-info">开播场次</p>
                   </div>
                   <div class="align-center">
                       <p class="yx-color-text-primary font-bold">323</p>
                       <p class="fz-12 mt-6 yx-color-info">开播场次</p>
                   </div>
                   <div class="align-center">
                       <p class="yx-color-text-primary font-bold">323</p>
                       <p class="fz-12 mt-6 yx-color-info">开播场次</p>
                   </div>
               </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogCooperVisible = false">取 消</el-button>
                <el-button type="primary" @click="cooperConfirm">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import productBox from '@/components/common/productBox';
import userInfoBox from '@/components/common/userInfoBox';
import tipsBox from '@/components/common/tipsBox';
import {drRoleType} from '@/utils/dataMap';
export default {
    components: {
        productBox,
        userInfoBox,
        tipsBox
    },
    name: 'cooperData',
    data() {
        return {
            dialogCooperVisible: false,
            formLabelWidth: '100px',
            row: {},
            tabName: ''
        }
    },
    computed: {
        drName() {
            return drRoleType.name;
        }
    },
    methods: {
        initCooperFun(row, tabName) {
            this.row = row;
            this.tabName = tabName;
            this.dialogCooperVisible = true;
        },
        cooperConfirm() {
            this.dialogCooperVisible = false
        }
    }
}
</script>
<style lang="less" scoped>
.tips{
    background: rgba(36, 117, 255, .1);
    border: 1px solid rgba(36, 117, 255, .3);
    padding: 11px 16px;
}
</style>